module.exports = __webpack_public_path__ + "static/img/icon-t.b7f15c99.png";